import { ChangeDetectionStrategy, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseCtrlValueAccessorFormArrayComponent, FormManagerService } from '@sim/form';
import { ClassName } from '@sim/role';

import { Contact, ContactMeta } from '../../models/person';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PersonContactFormComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PersonContactFormComponent),
    },
  ],
  selector: 'app-person-contact-form',
  styleUrls: ['./person-contact-form.component.scss'],
  templateUrl: './person-contact-form.component.html',
})
export class PersonContactFormComponent extends BaseCtrlValueAccessorFormArrayComponent<Contact> implements OnDestroy, OnInit {

  @Input() classNames: ClassName[] = [];

  constructor(
    private readonly formManager: FormManagerService,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage contact without a control');
    }

    const control = this.formManager.makeForm(ContactMeta, {} as Contact);
    this.form.push(control);
  }

  removeHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage contact without a control');
    }

    this.form.removeAt(index);
  }
}
